import { styled, Box } from "@mui/material";

export const S = {
    Page: styled(Box)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        gap: 65,
    })),

    Section: styled(Box)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        gap: 15,
    })),

    EmptySection: styled(Box)(({ theme }) => ({
        display: "flex",
        marginTop: 45,
        alignContent: "center",
        justifyContent: "center",
    })),

    Tab: styled(Box)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        gap: 15,
    })),
};
